import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Popup from "reactjs-popup";
import AdvertisingEnquiry from './AdvertisingEnquiry';
import Suggest from './Suggest';
import ReactGA from 'react-ga';

class Navbar extends Component {
  coffeeEvent() {
    ReactGA.initialize('UA-119876905-1');
    ReactGA.event({
      category: 'User',
      action: 'Clicked coffee link'
    });
  }

  render() {
    const framework_links = this.props.frameworks ? Object.keys(this.props.frameworks).map((framework_id) => 
      <Link key={"framework-" + framework_id} className="dropdown-item" to={"/framework/" + this.props.frameworks[framework_id].slug}>{this.props.frameworks[framework_id].title}</Link>
    ) : "";
    const category_links = this.props.categories ? Object.keys(this.props.categories).map((category_id) => 
      <Link key={"category-" + category_id} className="dropdown-item" to={"/category/" + this.props.categories[category_id].slug}>{this.props.categories[category_id].title}</Link>
    ) : "";
    const collection_links = this.props.collections ? Object.keys(this.props.collections).map((collection_id) => 
      <Link key={"collection-" + collection_id} className="dropdown-item" to={"/collection/" + this.props.collections[collection_id].slug}>{this.props.collections[collection_id].title} Models</Link>
    ) : "";

    //<Popup trigger={<li className="nav-item"><a className="nav-link suggest-link">Advertise</a></li>} modal closeOnDocumentClick>
    //<AdvertisingEnquiry />
    //</Popup>

    //<a href="http://buymeacoff.ee/modelzoo" target="_blank" className="nav-link">Buy Me Coffee</a>

    return <nav className="navbar navbar-expand-lg navbar-light ">
      <Link className="navbar-brand" to="/">ModelZoo</Link>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Frameworks</a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            {framework_links}
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Categories</a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            {category_links}
            </div>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Collections</a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            {collection_links}
            </div>
          </li>
        </ul>
        <ul className="navbar-nav">
          <Popup trigger={<li className="nav-item"><a className="nav-link suggest-link">Suggest a Model</a></li>} modal closeOnDocumentClick>
          <Suggest />
          </Popup>
          <li className="nav-item">
            <a href="http://buymeacoff.ee/modelzoo" className="nav-link" target="_blank">Buy Me a Coffee</a>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-link">Blog</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">About</Link>
          </li>
        </ul>
      </div>
    </nav>
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/Navbar.jsx